import styled from 'styled-components';

const MonthlySubscriptionDayPickerContainer = styled.div(
  ({ theme }) => `
    display: flex;
    padding: 0px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    row-gap: 4px;

    @media ${theme.media.tabletPortraitMin} {
      padding-top: 16px;
      padding-left: 16px;
      padding-bottom: 8px;
      padding-right: 16px;
      row-gap: 4px;
      box-shadow: 0 1px 3px 0 rgba(44, 20, 20, 0.08);
      background: #fff;
      border-radius: 12px;
    }

    @media ${theme.media.tabletLandscapeMin} {
      padding-left: 24px;
      padding-right: 24px;
      row-gap: 16px;
    }
  `
);

const WeekHeaderContainer = styled.div`
  width: 100%;
  height: 28px;
  display: flex;
  padding: 2px 0;
  flex-direction: row; /*In Figma it says column*/
  align-items: center;
  text-align: center;
`;

const DayLabel = styled.div(
  ({ theme }) => `
    padding: 4px;
    width: 100%;
    font-size: 14px;
    font-weight: 400;

    @media ${theme.media.tabletLandscapeMin} {
      font-size: 16px;
      font-weight: 500;
    }
  `
);

export { MonthlySubscriptionDayPickerContainer, WeekHeaderContainer, DayLabel };
